import { connect } from "react-redux";

import Home from "./home";
export { default as navigationSagas } from "./sagas";
export * from "./navigation.actions";

export default connect(({ user }: any, own) => {
  const { username } = user;
  return {
    username,
    ...own
  };
})(Home);
